export const ACTIONS_MUDAR_PERIODO = 'ACTIONS_MUDAR_PERIODO';
export const ACTIONS_MUDAR_MEDICO = 'ACTIONS_MUDAR_MEDICO';
export const ACTIONS_NOVA_MARCACAO = 'ACTIONS_NOVA_MARCACAO';
export const ACTIONS_LOGIN = 'ACTIONS_LOGIN';
export const ACTIONS_TOKEN = 'ACTIONS_TOKEN';
